import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';

import { ClassificacaoSelectComponent } from './classificacao-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        ClassificacaoSelectComponent
    ],
    exports: [
        ClassificacaoSelectComponent
    ]
})
export class ClassificacaoSelectModule { }
